// extracted by mini-css-extract-plugin
module.exports = {"chatbot__wrapper":"FaqChatbotTemplate_chatbot__wrapper__p1VRh"};